module.exports = __webpack_public_path__ + "img/h.ed2e86ce.jpg";